var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.layout,{tag:"component"},[_c('router-view'),_c('Snackbar',{ref:"snackbar"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }